/**
 * Wizard Step Component
 *
 * Represents an individual step in a wizard flow.
 * Conditionally renders based on the current active step.
 */

import React, { type ReactNode } from 'react';

export interface WizardStepProps {
  children: ReactNode;
  className?: string;
}

export const WizardStep: React.FC<WizardStepProps> = ({
  children,
  className = '',
}) => {
  return (
    <div className={`wizard-step ${className}`}>
      {children}
    </div>
  );
};
